export enum PushOrderFormFields {
  ORDER_ID = 'orderId',
}

export type TPushOrderFormValues = {
  [PushOrderFormFields.ORDER_ID]: string;
};
